import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSideSheetOverlay = styled.div`
  background-color: transparent;
  height: inherit;
  left: 0;
  opacity: ${({ $isCollapsed }) => ($isCollapsed ? 0 : 1)};
  position: absolute;
  right: 0;
  width: inherit;
  z-index: ${({ $isCollapsed, theme }) =>
    $isCollapsed ? theme.zIndex.hidden.value : theme.zIndex.sideSheetOverlay.value};
`;

const SideSheetOverlay = ({ className = '', dataTestId = undefined, isCollapsed = true, ...other }) => (
  <StyledSideSheetOverlay $isCollapsed={isCollapsed} {...{ className, dataTestId }} {...other} />
);

SideSheetOverlay.propTypes = {
  /** Adds additional className to SideSheet to override styling */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, component is collapsed */
  isCollapsed: PropTypes.bool,
};

export { SideSheetOverlay };
